<template>
  <div class="main-container">
    <div class="main-box">
      <h1>RacingMax</h1>
      <h2>QBE Motor Cycle Insurance System</h2>
      <div class="create-box">
        <span class="title">Create New Quote</span>
        <div class="create-btn">
          <el-button
            size="small"
            type="primary"
            @click="handleCreate('SSP')"
          >
            SSP
          </el-button>
          <el-button
            size="small"
            type="primary"
            @click="handleCreate('MK')"
          >
            MK
          </el-button>
        </div>
      </div>
      <div class="search-form">
        <span class="title">Retrieve Application</span>
        <div
          v-for="(item, index) in searchList"
          :key="index"
          class="tr"
        >
          <div class="td">
            {{ item.label }}
          </div>
          <div class="td">
            <v-input
              v-model="item.value"
              @keyEnter="handleSearch(index)"
            />
          </div>
          <div class="td">
            <el-button
              type="primary"
              size="small"
              @click="handleSearch(index)"
            >
              Search
            </el-button>
          </div>
        </div>
      </div>
      <div class="search-form">
        <span class="title">Show Daily Records</span>
        <div class="tr">
          <div class="td">Date</div>
          <div class="td">
            <v-date-picker
              v-model="issue_dt"
              @keyEnter="handlerSearchIssue" />
          </div>
          <div class="td">
            <el-button
              type="primary"
              size="small"
              @click="handlerSearchIssue"
            >
              Search
            </el-button>
          </div>
        </div>
      </div>
      <div class="search-form">
        <span class="title">Excel Data Download</span>
        <div class="tr-search">
          <div class="td">
            Start Date
          </div>
          <div class="td">
            <v-date-picker v-model="start_dt" />
          </div>
        </div>
        <div class="tr-search">
          <div class="td">
            End Date
          </div>
          <div class="td">
            <v-date-picker v-model="end_dt" />
          </div>
        </div>
        <div class="tr-search">
          <el-button
            size="small"
            type="primary"
            @click="handlerExport"
          >
            Export
          </el-button>
        </div>
      </div>
      <div
        v-if="showStatusLockInBatch"
        class="search-form"
      >
        <span class="title">Lock Data Function</span>
        <div class="tr-search">
          <div class="td">
            End Date
          </div>
          <div class="td">
            <v-date-picker v-model="lock_end_dt" />
          </div>
        </div>
        <div class="tr-search">
          <el-button
            size="small"
            type="success"
            @click="handlerExportUnlockPolicy"
          >
            Export
          </el-button>
          <el-button
            size="small"
            type="warning"
            @click="handlerLockInBatch"
          >
            Lock Data
          </el-button>
        </div>
      </div>
      <el-button
        class="btn-logout"
        size="small"
        @click="handlerLogout"
      >
        Logout
      </el-button>
    </div>
  </div>
</template>
<script>
import { downloadFile } from '@/jslib/file'
import { getAllOptions, logout, exportPolicy, lockInBatch } from '@/api'
import { mapState, mapActions } from 'vuex'
export default {
  name: 'MainContainer',
  data() {
    return {
      searchList: [
        {
          label: 'Registration Number',
          key: 'rgtn_no',
          value: ''
        },
        {
          label: 'Telephone Number',
          key: 'mobile_no',
          value: ''
        },
        {
          label: 'HKID Number',
          key: 'id_no',
          value: ''
        },
        {
          label: 'Cover Note Number',
          key: 'cvr_nt_no',
          value: ''
        },
        {
          label: 'Policy Number',
          key: 'pcy_no',
          value: ''
        }
      ],
      issue_dt: '',
      start_dt: '',
      end_dt: '',
      lock_end_dt: ''
    }
  },
  computed: {
    ...mapState('main', ['allOptions']),
    showStatusLockInBatch() {
      let userinfo = JSON.parse(localStorage.getItem('userinfo'))
      return userinfo && userinfo.super_admin
    }
  },
  created() {
    // if(!this.allOptions) {
    //   this.network().getAllOptions()
    // }

    this.updateAllOptions()
    const date = new Date()
    const month = String(date.getMonth() + 1).padStart(2, 0)
    const day = String(date.getDate()).padStart(2, 0)
    const year = date.getFullYear()
    this.issue_dt = `${day}-${month}-${year}`
  },
  methods: {
    ...mapActions('main', ['setAllOptions', 'updateAllOptions']),
    ...mapActions('policy', ['setPolicyForm', 'setPolicyId']),
    handlerLogout() {
      this.network().logout()
    },
    handlerExport() {
      if(this.start_dt && this.end_dt) {
        this.network().exportPolicy()
      }
    },
    handlerExportUnlockPolicy() {
      if(this.lock_end_dt) {
        this.network().exportUnlockPolicy()
      }
    },
    handlerLockInBatch() {
      if(this.lock_end_dt) {
        this.$confirm('你確認要鎖定在【' + this.lock_end_dt + '】或之前的正式保單？', '提示', {
          confirmButtonText: '確認',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.network().lockInBatch()
        }).catch(() => {
          return false
        })
      }
    },
    handleSearch(index) {
      const { key, value } = this.searchList[index]
      this.$router.push({
        path: '/policy',
        query: {
          [key]: value
        }
      })
    },
    handlerSearchIssue() {
      this.$router.push({
        path: '/policy',
        query: {
          issue_dt: this.issue_dt
        }
      })
    },
    handleCreate(value) {
      this.setPolicyForm(null) // 初始化
      this.setPolicyId('')
      this.$router.push({
        path: '/quotation',
        query: {
          office: value
        }
      })
    },
    network() {
      return {
        getAllOptions: async () => {
          const { data } = await getAllOptions()
          this.setAllOptions(data)
        },
        logout: async () => {
          await logout()
          localStorage.removeItem('token')
          this.setAllOptions(null)
          this.$router.replace('/login')
        },
        lockInBatch: async () => {
          const { data } = await lockInBatch({
            end_dt: this.lock_end_dt
          })
          if(data.code){
            this.$message({
              type: 'warning',
              message: data.message
            })
          }else{
            this.$message({
              type: 'success',
              message: data.message
            })
          }
        },
        exportPolicy: async () => {
          const { data, headers } = await exportPolicy({
            start_dt: this.start_dt,
            end_dt: this.end_dt
          })
          downloadFile(data, headers)
        },
        exportUnlockPolicy: async () => {
          const { data, headers } = await exportPolicy({
            unlock_only: 1,
            end_dt: this.lock_end_dt
          })
          downloadFile(data, headers)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.main-container {
  // display: flex;
  // justify-content: center;
  // align-items: center;
  // padding: 70px 0 70px 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background: #ddd;
  .main-box {
    position: relative;
    margin: 70px auto;
    padding: 50px;
    width: 600px;
    text-align: center;
    background: white;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    color: #303133;
    .btn-logout {
      position: absolute;
      top: 30px;
      right: 20px;
    }
    h1 {
      font-size: 32px;
    }
    h2 {
      font-size: 24px;
    }
    .create-box {
      margin: 35px auto 30px auto;
      .title {
        display: block;
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #303133;
      }
    }
    .search-form {
      margin-bottom: 15px;
      font-size: 16px;
      color: #616266;
      .title {
        display: block;
        margin-bottom: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #303133;
      }

      .tr-search {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        .td:first-child {
          width: 80px;
          text-align: right;
        }
        .td:nth-child(2) {
          margin-left: 10px;
          width: 250px;
        }
      }
      .tr {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 10px;
        .td:first-child {
          flex: 1;
          text-align: right;
        }
        .td:nth-child(2) {
          margin-left: 10px;
          width: 250px;
        }
        .td:last-child {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>